import { SVGProps, Ref, forwardRef } from 'react';

export const RadiusOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12 1c1.095 0 2.093.097 3 .278v1.84c-.87-.204-1.865-.318-3-.318-3.692 0-5.894 1.21-7.211 2.79C3.424 7.228 2.8 9.517 2.8 12s.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2s5.894-1.21 7.211-2.79C20.576 16.772 21.2 14.483 21.2 12c0-1.046-.11-2.057-.34-3h1.844c.203.977.296 1.989.296 3 0 5.5-2.75 11-11 11S1 17.5 1 12 3.75 1 12 1"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 2c-1.5 0-2 1-2 2 0 .22.024.44.078.65l-3.856 3.855C13.65 8.188 12.919 8 12 8c-3 0-4 2-4 4s1 4 4 4 4-2 4-4c0-.777-.151-1.555-.512-2.215l3.86-3.86Q19.635 6 20 6c1.5 0 2-1 2-2s-.5-2-2-2M9.8 12c0-.733.187-1.272.458-1.598.223-.267.675-.602 1.742-.602s1.52.335 1.742.602c.271.326.458.865.458 1.598s-.187 1.272-.458 1.598c-.223.267-.675.602-1.742.602s-1.52-.335-1.742-.602C9.987 13.272 9.8 12.733 9.8 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
RadiusOutlinedSize24Glyph.displayName = 'RadiusOutlinedSize24Glyph';
